module.exports = __webpack_public_path__ + "static/media/text-image.33f5dadd.avif";